var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TokenType } from './token';
/**
 * Manipulator for a stream of tokens returned from lexing.
 *
 * This is conceptually equivalent to, BUT behaviorally different from the
 * plugin version of TokenStream - that one ignores comments and needs a bunch
 * more logic for handling expressions, etc. - this one _needs_ comments in
 * certain situations.
 */
var TokenStream = /** @class */ (function () {
    function TokenStream(tokens) {
        this.index = 0;
        this.tokens = __spreadArray([], tokens, true);
        this.firstToken = tokens[0];
    }
    TokenStream.prototype.getTokens = function () {
        var tokens = [];
        for (var i = this.index; i < this.tokens.length; ++i) {
            tokens.push(this.tokens[i]);
        }
        return tokens;
    };
    TokenStream.prototype.hasTokens = function () {
        for (var i = this.index; i < this.tokens.length; ++i) {
            if (!isWhitespace(this.tokens[i])) {
                return true;
            }
        }
        return false;
    };
    /**
     * Peek at the first non-whitespace token in the stream without consuming
     * it.
     */
    TokenStream.prototype.peek = function () {
        for (var i = this.index; i < this.tokens.length; ++i) {
            if (!isWhitespace(this.tokens[i])) {
                return this.tokens[i];
            }
        }
        throw new TokenStreamEOFError(this.firstToken);
    };
    /**
     * Consume the first token in the stream, optionally including whitespace.
     */
    TokenStream.prototype.take = function (includeWhitespace) {
        for (var i = this.index; i < this.tokens.length; ++i) {
            var next = this.tokens[i];
            if (includeWhitespace || !isWhitespace(next)) {
                this.index = i + 1;
                return next;
            }
        }
        throw new TokenStreamEOFError(this.firstToken);
    };
    /**
     * Consume the first non-whitespace token in the stream while asserting
     * that it is of the given type.
     */
    TokenStream.prototype.takeExpect = function (expect) {
        if (!this.hasTokens()) {
            throw new TokenStreamEOFError(this.firstToken);
        }
        var first = this.take();
        if ((first === null || first === void 0 ? void 0 : first.type) !== expect) {
            throw new TokenStreamError('unexpected token', first);
        }
        return first;
    };
    /**
     * Take a complete line from the stream, including whitespace, and
     * excluding the newline at the end.
     */
    TokenStream.prototype.takeLine = function () {
        var line = [];
        var i;
        for (i = this.index; i < this.tokens.length; ++i) {
            var next = this.tokens[i];
            if (next.type === TokenType.NEWLINE) {
                ++i;
                break;
            }
            line.push(next);
        }
        this.index = i;
        return new TokenStream(line);
    };
    TokenStream.prototype.toString = function () {
        return this.getTokens()
            .map(function (t) {
            return t.type === TokenType.LITERAL_STRING ? "\"".concat(t.value, "\"") : t.value;
        })
            .join('');
    };
    TokenStream.prototype.takeInt = function () {
        return parseInt(this.takeExpect(TokenType.LITERAL_INT).value);
    };
    TokenStream.prototype.takeBool = function () {
        var first = this.take();
        switch (first.type) {
            case TokenType.TRUE:
                return true;
            case TokenType.FALSE:
                return false;
            default:
                throw new TokenStreamError('unexpected token', first);
        }
    };
    TokenStream.prototype.takeString = function () {
        return this.takeExpect(TokenType.LITERAL_STRING).value;
    };
    TokenStream.prototype.takeStringList = function () {
        return this.takeList().map(function (token) {
            if (token.type !== TokenType.LITERAL_STRING) {
                throw new TokenStreamError('unexpected token', token);
            }
            return token.value;
        });
    };
    TokenStream.prototype.takeList = function () {
        var list = [];
        this.takeExpect(TokenType.LIST_START);
        while (this.hasTokens()) {
            if (this.peek().type === TokenType.LIST_END) {
                return list;
            }
            list.push(this.take());
            var next = this.peek();
            if (next.type === TokenType.COMMA) {
                this.take();
            }
            else if (next.type === TokenType.LIST_END) {
                this.take();
                break;
            }
            else {
                throw new TokenStreamError('unexpected token', next);
            }
        }
        return list;
    };
    return TokenStream;
}());
export { TokenStream };
export function isWhitespace(token) {
    return (token.type === TokenType.WHITESPACE || token.type === TokenType.NEWLINE);
}
var TokenStreamError = /** @class */ (function (_super) {
    __extends(TokenStreamError, _super);
    function TokenStreamError(message, token) {
        var loc = token.location;
        return _super.call(this, "".concat(message, " '").concat(token.value, "' at line ").concat(loc.line, ", char ").concat(loc.char)) || this;
    }
    return TokenStreamError;
}(Error));
export { TokenStreamError };
var TokenStreamEOFError = /** @class */ (function (_super) {
    __extends(TokenStreamEOFError, _super);
    function TokenStreamEOFError(token) {
        return _super.call(this, "unexpected end of token stream near line ".concat(token.location.line)) || this;
    }
    return TokenStreamEOFError;
}(Error));
export { TokenStreamEOFError };
